var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("text-" + _vm.position)},[_c('router-link',{staticClass:"c-link--arrow",attrs:{"to":_vm.url}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }